import { type FC, useEffect, useState } from "react";
import { useDebouncedCallback } from "use-debounce";

import { ProgressBar, type ProgressBarProps } from "../../ProgressBar";
import { type TableCellValueCommonProps } from "./types";

export interface TableCellValueProgressBarProps extends TableCellValueCommonProps {
	label: string;
}

const PROGRESS_BAR_DEBOUNCE_MS = 200;

export const TableCellValueProgressBar: FC<TableCellValueProgressBarProps> = ({
	value,
	label,
	onChange,
	isEditable,
	renderAsRowDetail,
}) => {
	const [internalValue, setInternalValue] = useState(value);
	const onValueChange = useDebouncedCallback(onChange ?? (() => null), PROGRESS_BAR_DEBOUNCE_MS);
	const commonProps: ProgressBarProps = { size: "sm", label, showValueLabel: true };

	useEffect(() => {
		if (isEditable && value !== internalValue) {
			setInternalValue(value);
		}
	}, [value, isEditable]);

	const content = isEditable ? (
		<ProgressBar
			{...commonProps}
			value={internalValue}
			onValueChange={(value) => {
				setInternalValue(value);
				onValueChange(value);
			}}
		/>
	) : (
		<ProgressBar {...commonProps} value={value} />
	);

	return renderAsRowDetail ? <div className="w-96">{content}</div> : content;
};
